import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import { generateFacebookTargetingSpec } from '../../../helpers/facebookAdTargeting';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';
import Chip from 'material-ui/Chip';
import { changeAudienceValue, clearAudience, createAudience, getAudience, getReachEstimate, updateAudience } from 'redux/modules/audience';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { AccordionTargetingRow, AppLayout } from 'containers';
import { Accordion, AudienceCard, Spinner } from 'components';
import AudienceAgeGender from './AudienceAgeGender';
import AudienceConnections from './AudienceConnections';
import AudienceLocation from './AudienceLocation';
import AudienceCustom from './AudienceCustom';
import * as styles from './Audiences.scss';
var AudienceBuilder = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    theme: state.theme,
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    gettingSavedAudiences: state.adsAudiences.gettingSavedAudiences,
    targetingConfigData: state.audience.FacebookTargetingConfig.data,
    reachEstimate: state.audience.reachEstimate,
    audience: state.audience,
    targetingSentences: state.audience.targetingSentences,
    savedAudiences: state.adsAudiences && state.adsAudiences.savedAudiences[orgId] ? state.adsAudiences.savedAudiences[orgId] : []
  };
}, {
  changeAudienceValue: changeAudienceValue,
  clearAudience: clearAudience,
  createAudience: createAudience,
  getAudience: getAudience,
  getReachEstimate: getReachEstimate,
  updateAudience: updateAudience
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AudienceBuilder, _Component);

  var _super = _createSuper(AudienceBuilder);

  function AudienceBuilder(props) {
    var _this;

    _classCallCheck(this, AudienceBuilder);

    _this = _super.call(this, props);
    _this.state = {
      selectedCustomAudienceType: 1
    };
    return _this;
  }

  _createClass(AudienceBuilder, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.fbTargetingConfigId && !this.props.audience.FacebookTargetingConfigId) {
        this.props.getAudience(this.props.fbTargetingConfigId);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!_.isEqual(prevProps.targetingConfigData, this.props.targetingConfigData)) {
        this.props.getReachEstimate(this.props.organization.id, this.props.adAccount.adAccountId, this.props.targetingConfigData);
      }
    }
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var theme = this.props.theme;
      var targetingRow = /*#__PURE__*/React.createElement(AccordionTargetingRow, {
        changeFormValue: function changeFormValue(val) {
          return console.log("in accordion change val 2 ".concat(val));
        },
        adAccountId: this.props.adAccount.adAccountId
      });
      var audienceAgeAndGender = /*#__PURE__*/React.createElement(AudienceAgeGender, {
        adAccountId: this.props.adAccount.adAccountId
      });
      var audienceConnections = /*#__PURE__*/React.createElement(AudienceConnections, {
        adAccountId: this.props.adAccount.adAccountId
      });
      var audienceLocation = /*#__PURE__*/React.createElement(AudienceLocation, {
        adAccountId: this.props.adAccount.adAccountId
      });
      var audienceCustomAudiences = /*#__PURE__*/React.createElement(AudienceCustom, {
        adAccountId: this.props.adAccount.adAccountId
      });
      return /*#__PURE__*/React.createElement("div", {
        style: this.props.style
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          marginBottom: 24
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '1 0 50%'
        }
      }, /*#__PURE__*/React.createElement(TextField, {
        style: {
          width: 480
        },
        floatingLabelFixed: true,
        floatingLabelText: "Audience Name",
        type: "text",
        label: "Audience Name",
        placeholder: "Your Audience Name",
        className: "form-control",
        value: this.props.audience.name,
        onChange: function onChange(e, val) {
          _this2.props.changeAudienceValue({
            name: val
          });
        }
      }), /*#__PURE__*/React.createElement(Accordion, {
        name: "audienceBuilder",
        id: "audienceBuilder",
        style: {
          marginBottom: 24
        },
        sections: [{
          id: 'locations',
          label: 'Locations',
          content: audienceLocation
        }, {
          id: 'connections',
          label: 'Connections',
          content: audienceConnections
        }, {
          id: 'ageAndGender',
          label: 'Age & Gender',
          content: audienceAgeAndGender
        }, {
          id: 'targeting',
          label: 'Targeting',
          content: targetingRow
        }, {
          id: 'customAudiences',
          label: 'Custom Audiences',
          content: audienceCustomAudiences
        }].filter(function (o) {
          return o;
        })
      }), this.props.showSaveButton && /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: this.props.audience.isEdit ? 'Save Changes' : 'Save',
        disabled: this.props.audience.creatingAudience || this.props.audience.updatingAudience || !this.props.audience.name || this.props.audience.name === '',
        onClick: function onClick() {
          if (_this2.props.audience.isEdit) {
            _this2.props.updateAudience(_this2.props.organization.id, _this2.props.audience.name, _this2.props.audience.FacebookTargetingConfig.data, _this2.props.audience.FacebookTargetingConfigId, _this2.props.reachEstimate, _this2.props.targetingSentences).then(function () {
              browserHistory.push("/org/".concat(_this2.props.organization.id, "/ads/audiences"));
            });
          } else {
            _this2.props.createAudience(_this2.props.organization.id, _this2.props.audience.name, _this2.props.audience.FacebookTargetingConfig.data, _this2.props.reachEstimate, _this2.props.targetingSentences).then(function () {
              _this2.props.clearAudience();

              browserHistory.push("/org/".concat(_this2.props.organization.id, "/ads/audiences"));
            });
          }
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '1 0 45%',
          marginLeft: '5%'
        }
      }, this.props.reachEstimate && this.props.targetingSentences && /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'sticky',
          top: 92,
          marginRight: 36,
          marginTop: 92
        }
      }, /*#__PURE__*/React.createElement(AudienceCard, {
        audience: {
          reachEstimate: this.props.reachEstimate,
          targetingSentences: this.props.targetingSentences,
          name: this.props.audience.name
        },
        colors: theme.colors
      })))));
    }
  }]);

  return AudienceBuilder;
}(Component)) || _class);
export { AudienceBuilder as default };
AudienceBuilder.defaultProps = {
  style: {},
  showSaveButton: true
};